module.exports = __webpack_public_path__ + "static/tabBack@2x-53baf8929b0ba229c11b2c70df9bbbc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/why-marvel/tabBack@2x.png
// module id = 2725
// module chunks = 168707334958949